export enum EReduxState {
    initialState = 'initialState',
    pending = 'pending',
    fulfilled = 'fulfilled',
    rejected = 'rejected',
}

export enum ENodeEnv {
    Development = 'development',
    Production = 'production',
}